<template>
	<div ref="target" class="content-reveal">
		<slot name="content"></slot>
	</div>
</template>

<script>
import * as basicScroll from 'basicscroll';

export default {
	name: 'ContentReveal',
	mounted() {
		this.$nextTick(() => {
			const instance = basicScroll.create({
				elem: this.$refs.target,
				from: 'top-bottom', //element
				to: 'bottom-top', //viewport
				direct: true,
				inside: () => {
					this.$refs.target.classList.add('reveal-up');
				},
			});
			instance.start();
		});
	},
};
</script>

<style lang="scss" scoped></style>
